/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import  './Footer.css';

export default function Footer() {

  return (
    <div className="root">
      <div className="footer">
        <span className="text">© My Notes</span>
        <span className="spacer">·</span>
        <span className="text">2020</span>
      </div>
    </div>
  );
}
